import React from "react";
import "./Menu.css";

export function MenuOption({ active, line1, line2, Icon }) {

    return (
        <div className={`menu-option ${active && active===true && 'menu-option--active'}`}>
            {Icon && <Icon />}
            {line2 && line2 !== "" ? <h2>{line1} <br/> {line2}</h2>
            : <h2>{line1}</h2>}
        </div>
    );
}

export function MenuMaster({ active, line1, Icon }) {

    return (
        <div className={`menu-option ${active && active===true && 'menu-option--active'}`}>
            <span>{Icon}</span>
            <h2>{line1}</h2>
        </div>
    );
}

// export default MenuOption;